export default {
    data() {
        return {
            statusses: [],
            customFilters: ['status'],
        }
    },

    async created() {
        const { data } = await window.axios.get(route('invoices.statusses'));

        this.statusses = data
    },

    methods: {
        searchStatus(status) {
            let statusName = status !== null ? status.system_name : '';
            this.$refs.table.query.status = statusName;
            this.$refs.table.refresh();
        },
    }
}
